import { useState } from "react";
import PropTypes from "prop-types";
import {
  Snackbar,
  Alert,
  TextField,
  Box,
  InputAdornment,
  Icon,
} from "@mui/material";

function NINField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);

  return (
    <Box>
      <TextField
        id={`dff_${fieldRef}`}
        name={fieldRef}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const nin = e.target.value;
          const isnum = /^\d+$/.test(nin);
          if (!isnum || nin.length !== 11) {
            e.target.value = null;
            showFieldError(true);
          }
        }}
        options={options}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>shield</Icon>
            </InputAdornment>
          ),
        }}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          Invalid NIN provided.
        </Alert>
      </Snackbar>
    </Box>
  );
}

// Typechecking props of the Transaction
NINField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

NINField.defaultProps = {
  options: null,
};

export default NINField;
